import React from "react";
import { Outlet } from "react-router-dom";

const PathologyTest = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default PathologyTest;
